import { render, staticRenderFns } from "./TextTemplateContent.vue?vue&type=template&id=3783c9ec&scoped=true&"
import script from "./TextTemplateContent.ts?vue&type=script&lang=js&"
export * from "./TextTemplateContent.ts?vue&type=script&lang=js&"
import style0 from "./TextTemplateContent.less?vue&type=style&index=0&id=3783c9ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783c9ec",
  null
  
)

export default component.exports